import { render } from "./Features.vue?vue&type=template&id=116fe26b&scoped=true&ts=true&lang=pug"
import script from "./Features.vue?vue&type=script&lang=ts"
export * from "./Features.vue?vue&type=script&lang=ts"

import "./Features.vue?vue&type=style&index=0&id=116fe26b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116fe26b"]])

export default __exports__